import { orderXClient } from '@/service/client'
import {
  DataPayload,
  DbNewsHistoryRequest,
  DbNewsPostList,
  DbNewsVocabulary,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchDbNewsHistory(payload: DbNewsHistoryRequest = {}) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { dbNewsHistory: payload },
      { headers: { 'X-Decode-Key': 'datapayload' } }
    )
    const postList = data.dbNewsPostList
    if (!postList) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch DB news history',
      })
    }
    return postList as DbNewsPostList
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

/**
 * Discover the DB News trigger-filter vocabulary (sources / event types / coins /
 * tags) currently seen in the stream, so the trigger builder can suggest values
 * instead of relying on free text alone. The backend recomputes this at most once
 * every 5 minutes, so callers should cache accordingly (see useDbNewsVocabulary).
 */
export async function fetchDbNewsVocabulary(): Promise<DbNewsVocabulary> {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { getDbNewsVocabulary: {} },
      { headers: { 'X-Decode-Key': 'datapayload' } }
    )
    const vocabulary = data.dbNewsVocabulary
    if (!vocabulary) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch DB news vocabulary',
      })
    }
    return vocabulary
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
